import axios from "axios";

const API_URL = import.meta.env.VITE_API_URL;

const AcceptanceRulesService = {
    list: async (filters) => axios.post(API_URL + "/acceptance-rules/list", filters).then(({data}) => data).catch((err) => { throw err }),

    get: async (id) => axios.get(API_URL + "/acceptance-rules/" + id).then(({data}) => data).catch((err) => { throw err }),

    create: async (data) => axios.post(API_URL + "/acceptance-rules", data).then(({data}) => data).catch((err) => { throw err }),

    edit: async (id, data) => axios.post(API_URL + "/acceptance-rules/" + id, data).then(({data}) => data).catch((err) => { throw err }),

    delete: async (id) => axios.delete(API_URL + "/acceptance-rules/" + id).catch((err) => { throw err }),

    interconnectedCities: async () => axios.get(API_URL + "/acceptance-rules/get/interconnectedCities").then(({data}) => data).catch((err) => { throw err }),
};

export default AcceptanceRulesService;